module.exports = __webpack_public_path__ + "img/img_mp.9f10b5d9.png";